module.exports = __webpack_public_path__ + "img/AO.182ddd10.svg";